(function () {
    'use strict';

    function ServiceItemPriceInfoController($uibModal, $window, $scope, $state, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, PriceInfoDtailCustom, PriceInfoDtail, Principal, PackageFeatureListCustom) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.priceInfoDtails = null;
        $ctrl.confirmDelete = confirmDelete;
        $ctrl.addNewPriceInfoDtail = addNewPriceInfoDtail;
        $ctrl.priceInfos = [];
        $ctrl.removePriceInfoDtail = removePriceInfoDtail;
        $ctrl.reload = 'false';
        $ctrl.fixedPriceInfoEnum = ['HOURLY', 'DAILY', 'MONTHLY'];
        $ctrl.initFixedPriceInfo = initFixedPriceInfo;
        $ctrl.fixedPriceInfoDetails = [];
        $ctrl.priceInfoType = 'dynamic';
        $ctrl.hasAdvancedPricingFeatureAccess = true;

        loadAll();

        loadPage();

        function loadAll() {

            //
            if ($ctrl.serviceItemId == undefined || $ctrl.serviceItemId == null) {
                $ctrl.priceInfos = [];
                initFixedPriceInfo();
            } else {
                $ctrl.priceInfos = [];
                PriceInfoCustom.getPriceInfosWithDtailsByServiceItem($ctrl.serviceItemId).query().$promise.then(function (result) {
                    $ctrl.priceInfos = result;
                    initFixedPriceInfo();
                });
            }


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            $ctrl.reload == 'false';


        }

        function loadPage(page) {
            translatePartialLoader.addPart('priceInfo');
            translatePartialLoader.addPart('priceInfoDtail');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            //
            loadAll();
            checkFeatureAccess();
        }

        function newItem() {
            //
            $ctrl.formState = 'new';
            $ctrl.priceInfoDtail = {};
            $ctrl.priceInfoDtail.capacityRatio = 1;  //
            $ctrl.priceInfoDtail.title = '';  //
            $ctrl.newPriceInfo = {};

            addNewPriceInfoDtail();

            //$ctrl.onCreateNewPriceInfo();

        }

        function editItem(id) {
            //
            $ctrl.formState = 'edit';
            //$ctrl.selectedId=id;
            //$ctrl.onSelectedPriceInfoChanged(id);

            $ctrl.newPriceInfo = PriceInfoCustom.getPriceInfoWithDtailById(id).query();

            //

        }

        function backToList() {
            $ctrl.formState = 'list';
            loadAll();
        }


        function confirmDelete(id) {

            $uibModal.open({
                templateUrl: 'app/entities/price-info/service-item-price-info-delete-dialog.html',
                controller: 'ServiceItemPriceInfoDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {

                    entity: ['PriceInfo', function (PriceInfo) {
                        return PriceInfo.get({id: id}).$promise;
                    }]
                }
            }).result.then(function (result) {
                $ctrl.priceInfos = $ctrl.priceInfos.filter(function (v) {
                        return (v.id != id)
                    }
                );
            }, function () {
                //nothing
            });


        }

        function addNewPriceInfoDtail() {
            if ($ctrl.newPriceInfo == null || $ctrl.newPriceInfo == undefined)
                $ctrl.newPriceInfo = {};
            if ($ctrl.newPriceInfo.priceInfoDtails == null || $ctrl.newPriceInfo.priceInfoDtails == undefined)
                $ctrl.newPriceInfo.priceInfoDtails = [];


            $ctrl.newPriceInfo.priceInfoDtails.push({
                title: "",
                price: ""
            });

        }

        function removePriceInfoDtail(title) {
            $ctrl.newPriceInfo.priceInfoDtails = $ctrl.newPriceInfo.priceInfoDtails.filter(function (v) {
                return (v.title != title)
            });

        }

        function initFixedPriceInfo() {


            if ($ctrl.priceInfoType == 'fixed') {
                if ($ctrl.priceInfos == null || $ctrl.priceInfos == undefined || $ctrl.priceInfos.length == 0) {
                    $ctrl.priceInfos = [];
                    $ctrl.newPriceInfo = {};

                    var priceInfo = {};
                    priceInfo.id = null;
                    priceInfo.fromValidDate = null;
                    priceInfo.priceType = 'FIXED';

                    priceInfo.priceInfoDtails = [];

                    priceInfo.priceInfoDtails.push({
                        title: "HOURLY",
                        price: 0,
                        capacityRatio: 1,
                    });
                    priceInfo.priceInfoDtails.push({
                        title: "DAILY",
                        price: 0,
                        capacityRatio: 1,
                    });
                    priceInfo.priceInfoDtails.push({
                        title: "MONTHLY",
                        price: 0,
                        capacityRatio: 1,
                    });

                    $ctrl.newPriceInfo = priceInfo;

                    $ctrl.fixedPriceInfoDetails = $ctrl.newPriceInfo.priceInfoDtails;

                } else if ($ctrl.priceInfos.length > 0) {
                    $ctrl.newPriceInfo = $ctrl.priceInfos[0];
                    $ctrl.fixedPriceInfoDetails = $ctrl.newPriceInfo.priceInfoDtails;
                }
            }
        }

        function checkFeatureAccess() {
            PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                Principal.setCurrentCompanyFeatureList(result);
                $ctrl.hasAdvancedPricingFeatureAccess = Principal.hasSpecialFeatureAccess('advancedPricing');
            })
        }

        $scope.$watch('$ctrl.formState', function () {
            if ($ctrl.formState == 'list') {
                loadAll();
            }
        });

        $scope.$watch('$ctrl.reload', function () {
            if ($ctrl.reload == 'true') {
                loadAll();

            }
        });

        $scope.$watch('$ctrl.priceInfoType', function () {
            if ($ctrl.priceInfoType == 'fixed') {
                loadAll();
            }
        });


    }

    var ServiceItemPriceInfo = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/service-item-price-info/partial-form.service-item-price-info.html',
        controller: ServiceItemPriceInfoController,
        bindings: {
            serviceItemId: '<',
            selectedId: '=?',
            formState: '=',
            onSelectedPriceInfoChanged: '=',
            newPriceInfo: '=',
            reload: '=',
            priceInfos: '=',
            priceInfoType: '='
            //onCreateNewPriceInfo:'='


            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfServiceItemPriceInfo', ServiceItemPriceInfo)

    ServiceItemPriceInfoController.$inject = ['$uibModal', '$window', '$scope', '$state', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'PriceInfoDtailCustom', 'PriceInfoDtail', 'Principal', 'PackageFeatureListCustom'];


})();

